<div class="mb-4">
  <div data-test-id="status-details-description">
    {{ 'websites_apps_by_risk_management_status_details_description' | translate }}
  </div>
  <div data-test-id="computed-date">{{ computedDateDescription$ | async }}</div>
</div>

<ds-tabs (activeIdChange)="tabIdChange($event)" [tablistLabelledBy]="titleId">
  @for (level of riskScoreLevels; track level) {
    <ds-tab [label]="tabLabels[level]" [heading]="tabLabels[level]">
      @if (collectionSize$ | async) {
        <ds-pagination
          class="d-block mb-3"
          [hidePaginationNavigation]="true"
          [resultsName]="'websites_apps' | translate"
          [collectionSize]="collectionSize$"
          [page]="page"
        >
        </ds-pagination>
      }
      <app-ngb-table
        id="websites-apps-by-risk-management-status-details-table"
        (onSort)="sortTableData($event)"
        [config]="tableConfig"
        [data]="tableData"
      ></app-ngb-table>
      @if (collectionSize$ | async) {
        <ds-pagination
          (pageChange)="changePage($event)"
          [resultsName]="'websites_apps' | translate"
          [collectionSize]="collectionSize$"
          [page]="page"
        >
        </ds-pagination>
      }
    </ds-tab>
  }
</ds-tabs>
